<template>
    <div class="tqStepper">

        <!-- steps -->
        <div class="steps">
            <div v-for="(step, stepIndex) in steps"
                 :class="{
                    'currentStep'   : currentStepIndex === stepIndex,
                    'finish'        : currentStepIndex > stepIndex,
                 }"
                 class="step"
                 @click="clickStep(stepIndex)"
                 :style="{'width': getStepWidthCSS}">

                <div class="imageWrapper">
                    <img :src="step.imgSrc"/>
                </div>

                <div class="label"> {{step.label[store_systemLangCode]}}</div>
            </div>

            <div class="line"></div>
            <div class="lineProgress" :style="{'width': getLineProgressWidth}"></div>
        </div>

        <div class="TQ_scrollable TQ_bg_gray4"
             :style="{'height' : bodyHeight, 'max-height' : p_maxHeight_s}"
             v-for="(step, stepIndex) in steps"
             :key="stepIndex"
             v-if="stepIndex === currentStepIndex">
            <slot :name="step.name"></slot>


            <div class="TQ_grid_col_Auto1frAuto TQ_margin_8px" v-if="!co_lastFirstStep_b">

                <!-- back btn-->
                <div class="TQ_btn TQ_bg_white TQ_grid_center">
                    <!-- cancel -->
                    <div @click="clickCancelFunc" v-if="isFirstStep">
                        {{ass_strings.oneWord_cancel[store_systemLangCode]}}
                    </div>
                    <!-- prev -->
                    <div @click="prevStep" v-if="hasPrevStep">
                        {{ass_strings.oneWord_prev[store_systemLangCode]}}
                    </div>
                </div>

                <!-- space-->
                <div ></div>

                <!-- next btn -->
                <div class="TQ_grid_center">
                    <!-- not finish -->
                    <div v-if="!hasNextStep">
                        {{steps[currentStepIndex].notFinishMsg[store_systemLangCode]}}
                    </div>

                    <!-- next -->
                    <div class="TQ_btn TQ_bg_purple_lite" @click="nextStep" v-if="hasNextStep">
                        {{ass_strings.oneWord_next[store_systemLangCode]}}
                    </div>
                </div>
            </div>


        </div>


        <!--<div class="bottomBar">-->

            <!--<div class="left">-->
                <!--&lt;!&ndash; cancel &ndash;&gt;-->
                <!--<div class="prevBtn " @click="clickCancelFunc" v-if="isFirstStep">-->
                    <!--{{ass_strings.oneWord_cancel[store_systemLangCode]}}-->
                <!--</div>-->
                <!--&lt;!&ndash; prev &ndash;&gt;-->
                <!--<div class="prevBtn" @click="prevStep" v-if="hasPrevStep">-->
                    <!--{{ass_strings.oneWord_prev[store_systemLangCode]}}-->
                <!--</div>-->
            <!--</div>-->

            <!--<div class="space"></div>-->

            <!--<div class="right">-->
                <!--&lt;!&ndash; not finish &ndash;&gt;-->
                <!--<div class="notFinishMessage" v-if="!hasNextStep">-->
                    <!--{{steps[currentStepIndex].notFinishMsg[store_systemLangCode]}}-->
                <!--</div>-->

                <!--&lt;!&ndash; next &ndash;&gt;-->
                <!--<div class="nextBtn" @click="nextStep" v-if="hasNextStep">-->
                    <!--{{ass_strings.oneWord_next[store_systemLangCode]}}-->
                <!--</div>-->
            <!--</div>-->


        <!--</div>-->

    </div>
</template>

<script>
    import OnTopContainer from "./TqOnTopContainer";
    import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";

    export default {
        name: "TqStepper",
        components: {OnTopContainer},
        props:{
            steps:{
                require:true,
                type: Array,
                validator: function (arr) {
                    for(let key in arr) {
                        if (typeof arr[key] !== 'object'){
                            return false
                        }
                    }
                    return true

                }
            },
            bodyHeight:{
                type: String,
                // default: '100px'
            },
            p_maxHeight_s:{
                type: String,
                default: '100%'
            },
            store_systemLangCode:{
                type: String,
                require: true
            },
            clickCancelFunc:{
                type: Function,
                default: () =>{}
            },

        },
        data(){
            return {
                currentStepIndex: 0,
                ass_strings: ass_strings

            }
        },
        methods:{


            nextStep(){
                if(this.hasNextStep)
                    this.currentStepIndex ++
            },
            prevStep(){
                if(this.hasPrevStep)
                    this.currentStepIndex --
            },
            clickStep(stepIndex){

                if(stepIndex === 0 ||
                    this.steps[stepIndex - 1].finishStep_f())
                    this.currentStepIndex = stepIndex
            }
        },
        computed:{
            getStepWidthCSS(){
                return (100/this.steps.length)+ '%'
            },
            getLineProgressWidth(){

                let ans = (100/(this.steps.length)) / 2

                ans += (100/(this.steps.length) * (this.currentStepIndex));

                return ans + '%'
            },
            hasNextStep(){
                return this.currentStepIndex < this.steps.length
                    &&  this.steps[this.currentStepIndex].finishStep_f()
            },
            hasPrevStep(){
                return this.currentStepIndex > 0
            },
            nextBtnText(){
                return this.currentStepIndex + 1 === this.steps.length ? "Finish" : "Next"
            },
            isFirstStep(){
                return this.currentStepIndex === 0
            },
            co_lastFirstStep_b(){
                return this.currentStepIndex === this.steps.length - 1
            }
        }
    }
</script>

<style scoped lang="scss">

    .tqStepper{

        display: grid;
        grid-template-rows: auto 1fr auto ;

        .steps{
            height: 52px;
            border-bottom: 1px solid black;
            padding-bottom: 12px;

            .step{
                cursor: pointer;
                display: inline-block;

                .imageWrapper{
                    /*background: white;*/
                    display: inline-block;
                    /*padding: 0 2px;*/

                    img{
                        background: var(--color-gray1);
                        width: 22px;
                        border-radius: 50%;
                        padding: 6px;
                        box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
                    }

                }

                .label{
                    text-transform: capitalize;

                }

                &.finish{
                    img{
                        background: var(--color-green);
                    }
                }
                &.currentStep{
                    font-weight: bold;
                    transform: scale(1.1);
                    color: var(--color-gold);

                    img{
                        background: var(--color-gold);
                        transform: scale(1.1);
                        /*box-shadow: 0 0 0 0 rgba(0,0,0,0.2);*/
                    }

                }
            }

            .line{
                margin-top: -40px;
                height: 2px;
                background: var(--color-gray1);
            }

            .lineProgress{
                margin-top: -3px;
                height: 4px;
                background: var(--color-green);
                /*width: 40%;*/
            }

        }

        .body{
            /*padding: 4px;*/
        }

        .bottomBar{
            /*display: flow-root;*/
            display: grid;
            grid-template-columns:auto 1fr auto;
            border-top: 1px solid black;
            padding-top: 8px;

            .left{
                /*float: left;*/
                display: inline-block;

                .prevBtn{
                    padding: 8px;
                    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
                    cursor: pointer;
                    font-size: 20px;
                    display: inline-block;

                }
            }

            .right{
                /*float: right;*/
                display: inline-block;
                .nextBtn{
                    background: #501078;
                    background: var(--color-purple);
                    color: white;
                    padding: 8px;
                    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
                    cursor: pointer;
                    font-size: 20px;
                    display: inline-block;

                }

                .notFinishMessage{
                    line-height: 37px;
                    float: right;
                }
            }

        }

    }





</style>